import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initTelemetry, TelemetryErrorBoundary, ReportProblem } from '@cca/ui';
import { App } from './App';

// Design system first (role tokens + base + themes + the canonical component
// classes), then Corpus-specific styles on top.
import '@cca/ui/styles';
import '@cca/ui/components';
import './styles/app.css';

// Production telemetry (Phase 4): window errors, unhandled rejections, render +
// API failures. Same-origin endpoint (worker is on liturgy.*/api).
const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';
initTelemetry({ portal: 'corpus', endpoint: `${apiBase}/api/telemetry` });

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

createRoot(root).render(
  <StrictMode>
    <TelemetryErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ReportProblem />
    </TelemetryErrorBoundary>
  </StrictMode>,
);
